import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  EntitlementVm, AccessCheckDto, AccessCheckResultVm,
  OverrideVm, CreateOverrideDto, EntitlementTokenVm, ModuleTier,
} from '../models';
import { enumName } from '../utils/enum.util';

@Injectable({ providedIn: 'root' })
export class EntitlementService {
  private http = inject(HttpClient);

  private normalize(e: EntitlementVm): EntitlementVm {
    return { ...e, modules: (e.modules ?? []).map((m) => ({ ...m, effectiveTier: enumName(ModuleTier, m.effectiveTier) })) };
  }

  getEntitlements(tenantId: string): Observable<EntitlementVm> {
    return this.http.get<EntitlementVm>(`${environment.apiBaseUrl}/tenants/${tenantId}/entitlements`).pipe(map((e) => this.normalize(e)));
  }

  getUserEntitlements(tenantId: string, userId: string, organizationId: string): Observable<EntitlementVm> {
    const params = new HttpParams().set('userId', userId).set('organizationId', organizationId);
    return this.http.get<EntitlementVm>(`${environment.apiBaseUrl}/tenants/${tenantId}/entitlements/user`, { params }).pipe(map((e) => this.normalize(e)));
  }

  checkAccess(tenantId: string, dto: AccessCheckDto): Observable<AccessCheckResultVm> {
    return this.http.post<AccessCheckResultVm>(`${environment.apiBaseUrl}/tenants/${tenantId}/entitlements/check`, dto);
  }

  getOverrides(tenantId: string): Observable<OverrideVm[]> {
    return this.http.get<OverrideVm[]>(`${environment.apiBaseUrl}/tenants/${tenantId}/overrides`);
  }

  createOverride(tenantId: string, dto: CreateOverrideDto): Observable<OverrideVm> {
    return this.http.post<OverrideVm>(`${environment.apiBaseUrl}/tenants/${tenantId}/overrides`, dto);
  }

  deleteOverride(tenantId: string, overrideId: string): Observable<void> {
    return this.http.delete<void>(`${environment.apiBaseUrl}/tenants/${tenantId}/overrides/${overrideId}`);
  }

  mintToken(tenantId: string): Observable<EntitlementTokenVm> {
    return this.http.post<EntitlementTokenVm>(`${environment.apiBaseUrl}/tenants/${tenantId}/entitlements/token`, {});
  }
}
